module.exports = __webpack_public_path__ + "static/media/eye-grey.a4b7e7c2.svg";